import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListNodeRequest extends IBaseRequest {
    timestamp?:      string;
    limit?:          number;
    offset?:         number;
    orderBy?:        string;
    countOnly?:      boolean;
    onlyType?:       string;
    onlyTypeStrict?: string;
    parent?:         number;
    parentSystemId?: string;
    skipNode?:       boolean;
    recursive?:      number;
}

export class ListNodeRequest extends BaseRequest implements IListNodeRequest {
    public timestamp?:      string;
    public limit?:          number;
    public offset?:         number;
    public orderBy?:        string;
    public countOnly?:      boolean;
    public onlyType?:       string;
    public onlyTypeStrict?: string;
    public parent?:         number;
    public parentSystemId?: string;
    public skipNode?:       boolean;
    public recursive?:      number;
  constructor(server: string, session: string, otherOptions?: any) {
    super(server, session);
    this.timestamp = otherOptions?.timestamp;
    this.limit = otherOptions?.limit;
    this.offset = otherOptions?.offset;
    this.orderBy = otherOptions?.orderBy;
    this.countOnly = otherOptions?.countOnly;
    this.onlyType = otherOptions?.onlyType;
    this.onlyTypeStrict = otherOptions?.onlyTypeStrict;
    this.parent = otherOptions?.parent;
    this.parentSystemId = otherOptions?.parentSystemId;
    this.skipNode = otherOptions?.skipNode;
    this.recursive = otherOptions?.recursive;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    parameters += this.makeNode(this.timestamp, 'timestamp');
    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    parameters += this.makeNode(this.onlyType, 'onlyType');
    parameters += this.makeNode(this.onlyTypeStrict, 'onlyTypeStrict');
    parameters += this.makeNode(this.parent, 'parent');
    parameters += this.makeNode(this.parentSystemId, 'parentSystemId');
    parameters += this.makeNode(this.skipNode, 'skipNode');
    parameters += this.makeNode(this.recursive, 'recursive');
    return super.wrapperXml('ListNode', parameters);
  }
}
